import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isStaffUser } from "@/lib/constants";
import StaffCourse from "@/components/course/StaffCourse";
import ParentCourse from "@/components/course/ParentCourse";

export default function CourseView() {
  const { id } = useParams();
  const { user } = useAuth();
  const [course, setCourse] = useState(null);
  const [error, setError] = useState(false);

  const load = () => api.get(`/courses/${id}`).then(({ data }) => setCourse(data)).catch(() => setError(true));
  useEffect(() => { setCourse(null); setError(false); load(); /* eslint-disable-next-line */ }, [id]);

  if (error) return <div className="px-8 py-10 text-muted-foreground">Kurs nicht gefunden oder kein Zugriff.</div>;
  if (!course) return <div className="px-8 py-10 text-muted-foreground">Wird geladen…</div>;

  return isStaffUser(user)
    ? <StaffCourse course={course} reload={load} />
    : <ParentCourse course={course} />;
}
